/**
 * Domain error codes surfaced through GraphQL `extensions.code`.
 * Frontends switch on these — never on human-readable messages.
 */
export const DOMAIN_ERROR_CODES = [
	"VALIDATION_FAILED",
	"NOT_FOUND",
	"UNAUTHENTICATED",
	"FORBIDDEN",
	"RATE_LIMITED",
	"QUERY_TOO_DEEP",
	"QUERY_TOO_COSTLY",
	"CONSENT_REQUIRED",
	"CAPTCHA_FAILED",
	"DUPLICATE_LEAD",
	"GATED_RESOURCE",
	"UPSTREAM_UNAVAILABLE",
	"INTERNAL",
] as const;

/** Union of all machine-readable domain error codes. */
export type DomainErrorCode = (typeof DOMAIN_ERROR_CODES)[number];

/** Canonical serialized shape of a domain error surfaced via GraphQL extensions. */
export interface DomainErrorShape {
	code: DomainErrorCode;
	message: string;
	correlationId?: string;
	fields?: { path: string; message: string }[];
}
